import Emmitery from 'emittery';
import * as eventConstants from './events';

const eventEmitter = new Emmitery();
export default eventEmitter;

export const events = eventConstants;
